/**
 * 락업 현황 팝업 (2026-10-03) — 시세/구독 팝업과 같은 틀(인라인 색 고정).
 * 지갑 카드의 락업 배지를 눌렀을 때만 뜬다. 화면에 상시 노출하지 않는다.
 */
import { X, Lock, CalendarClock } from 'lucide-react';

type Sched = { date: string; amount: number };

export function LockupModal({ open, onClose, locked, schedule }: {
  open: boolean; onClose: () => void; locked: number; schedule: Sched[];
}) {
  if (!open) return null;
  const next = schedule[0];
  return (
    <div className="fixed inset-0 flex items-center justify-center"
      style={{ zIndex: 300, background: 'rgba(0,0,0,.6)', padding: '16px 20px 110px' }}>
      <div className="w-full flex flex-col"
        style={{ background: '#FFFFFF', color: '#111827', maxWidth: 420,
                 maxHeight: '72vh', borderRadius: 20, overflow: 'hidden' }}>
        <div className="flex items-center justify-between"
          style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb' }}>
          <h3 style={{ fontSize: 18, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 8 }}>
            <Lock style={{ width: 18, height: 18, color: '#F59E0B' }} /> 락업 현황
          </h3>
          <button onClick={onClose} aria-label="닫기" className="flex items-center justify-center"
            style={{ width: 36, height: 36, borderRadius: 999, background: '#111827', flexShrink: 0 }}>
            <X className="h-5 w-5" style={{ color: '#FFFFFF' }} />
          </button>
        </div>

        <div style={{ padding: 20, overflowY: 'auto', flex: 1 }}>
          <p style={{ fontSize: 13, color: '#6B7280' }}>잠겨 있는 수량</p>
          <p style={{ fontSize: 28, fontWeight: 800, marginTop: 2 }}>
            {locked.toLocaleString('ko-KR', { maximumFractionDigits: 2 })}
            <span style={{ fontSize: 15, fontWeight: 600, color: '#6B7280' }}> wHANDY</span>
          </p>

          {next && (
            <div className="flex items-center justify-between"
              style={{ marginTop: 14, padding: '12px 14px', borderRadius: 12,
                       background: '#FFF4EC', border: '1px solid #FED7AA' }}>
              <span style={{ fontSize: 14, fontWeight: 700, display: 'flex', alignItems: 'center', gap: 6 }}>
                <CalendarClock style={{ width: 16, height: 16, color: '#F97316' }} /> 다음 해제
              </span>
              <b style={{ fontSize: 14 }}>
                {next.date} · +{next.amount.toLocaleString('ko-KR', { maximumFractionDigits: 1 })}
              </b>
            </div>
          )}

          {schedule.length > 0 && (
            <div style={{ marginTop: 14, border: '1px solid #e5e7eb', borderRadius: 14, overflow: 'hidden' }}>
              {schedule.map((r, i) => (
                <div key={r.date} className="flex items-center justify-between"
                  style={{ padding: '10px 14px', fontSize: 14,
                           ...(i ? { borderTop: '1px solid #f3f4f6' } : {}) }}>
                  <span style={{ color: '#6B7280' }}>{r.date}</span>
                  <b>+{r.amount.toLocaleString('ko-KR', { maximumFractionDigits: 1 })} wHANDY</b>
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={{ padding: '12px 20px 20px', borderTop: '1px solid #f3f4f6' }}>
          <button onClick={onClose}
            style={{ width: '100%', padding: '14px 0', borderRadius: 14, fontSize: 16,
                     fontWeight: 700, background: '#111827', color: '#FFFFFF', border: 0 }}>
            닫기
          </button>
        </div>
      </div>
    </div>
  );
}
